import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, signal } from '@angular/core';
import { AuthService } from '@skylab-angular-shared/config';
import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { ButtonComponent, DialogButtonResult, DialogContentComponentBase, DialogContentComponentIns, DialogHeaderComponentIns, DialogState } from '@skylab-angular-shared/ui';

@Component({
	selector: 'skl-session-expired-dialog',
	template: `
		<skl-dialog-content-ins>
			<skl-dialog-header-ins
				[title]="'config.interceptor.401-status.title' | translate"
				[closeVisible]="false">
			</skl-dialog-header-ins>
			<ins-content>
				<div class="align--small">
					{{'config.interceptor.401-status.message' | translate}}
				</div>
			</ins-content>

			<ins-footer class="dialog__buttons">
				<skl-button
					typeName="accent"
					[spinner]="confirmed()"
					(click)="onConfirm()">
					{{'config.interceptor.401-status.login' | translate}}
				</skl-button>
			</ins-footer>
		</skl-dialog-content-ins>
	`,
	imports: [TranslatePipe, DialogContentComponentIns, DialogHeaderComponentIns, ButtonComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SessionExpiredDialogComponent extends DialogContentComponentBase<any> {
	public confirmed = signal(false);
	private authService = inject(AuthService);

	public override ngOnInit(): void {
		super.ngOnInit();
		document.addEventListener('keyup', this.onKeyUpCapture, true);
	}

	public onConfirm(): void {
		this.onAction({state: DialogState.Confirm});
	}

	private onKeyUpCapture(event: KeyboardEvent): void {
		if (event.key === 'Escape') {
			event.stopPropagation();
		}
	};

	public override onAction(data: DialogButtonResult): void {
		if (data.state !== DialogState.Confirm) return;
		this.confirmed.set(true);
		this.authService.redirectToLoginPage();
	}
}
